import { Box, IconButton, MenuItem, Select, Typography } from "@material-ui/core";
import React from "react";
import { useParams } from "react-router";
import userReservationStyles from "../../../../assests/styles/views/public/userReservation";
import {
  EnglishLanguageIcon,
  FrenchLanguageIcon,
  GermanLanguageIcon,
} from "../../../../components/icons";
import { Logo } from "../../../../components/Logo";
import LanguageSelector from "../languageSelector";
import { getTranslation } from "../../../../heplers/translationHelper";

const Navbar = ({classes,supportEmail}) => {
  // const {primaryColor,secondaryColor} = useParams();
  // const classes = userReservationStyles({ primaryColor : "green",secondaryColor : "rgba(255, 35, 35, 0.83)"});
  return (
    <nav className={classes.navbar}>
      {/* <div className={classes.logoWrapper}>
        <Logo className={classes.img} />
      </div> */}
      <LanguageSelector isPublic />
      <Box display="flex" justifyContent="right">
        <Typography> {getTranslation("Support Email","Support Email","Support Email")} :	<a href={`mailto:${supportEmail}`}>{supportEmail}</a></Typography>
      </Box>
    </nav>
  );
};

export default Navbar;
